<template>
  <transactions-table
    :is-billsRegistryItems-loading="isBillsRegistryItemsLoading"
    class="bills-registries-table"
    grid-template-columns="1fr 1.3fr 0.7fr 0.4fr 0.4fr 140px 60px"
  >
    <template #tableHeader>
      <transactions-table-header
        class="transactions-table__header"
        :header-cols="$options.BILLS_HEADER_COLS"
        @sortChanged="handleSortChanged"
      ></transactions-table-header>
    </template>
    <template #transactionItems>
      <bills-registry-created-table-item
        v-for="registryItem in billsRegistryItemsPaged"
        :bills-registry-item="registryItem"
        :key="registryItem.id"
        @update:value="handleBillsRegistryItemUpdated"
        @deleted="handleBillsRegistryItemDeleted"
      ></bills-registry-created-table-item>
    </template>
    <template #tablePagination>
      <transactions-table-pagination
        @changePage="handlePageChanged"
        :current-page="currentPage"
        :items-count="billsRegistryItemsFiltered.length"
        :per-page="perPage"
      ></transactions-table-pagination>
    </template>
  </transactions-table>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import TransactionsTable from '@vue-app/components/company/transactions/table/TransactionsTable.vue'
import TransactionsTableHeader from '@vue-app/components/company/transactions/table/TransactionsTableHeader.vue'
import TransactionsTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import TransactionsTablePagination from '@vue-app/components/company/transactions/table/TransactionsTablePagination.vue'
import BillsRegistryCreatedTableItem from '@vue-app/components/company/bills/by-registry/created/table/BillsRegistryCreatedTableItem.vue'
import { mapState } from 'vuex'
export default {
  name: 'BillsRegistryCreatedTable',
  props: {
    billsRegistryItems: {
      type: Array,
      default() {
        return []
      },
    },
    isBillsRegistryItemsLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TransactionsTable,
    TransactionsTableItem,
    TransactionsTableHeader,
    TransactionsTablePagination,
    BillsRegistryCreatedTableItem,
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    sort: {
      col: null,
      dir: null,
    },
  }),
  BILLS_HEADER_COLS: [
    {
      id: 'date',
      title: 'bills.by-registry.created.table.column.date',
      additionalClasses: ['transactions-table-header__col--date'],
    },
    {
      id: 'recipient',
      title: 'bills.by-registry.created.table.column.recipient',
      additionalClasses: ['transactions-table-header__col--recipient'],
    },
    {
      id: 'phone',
      title: 'bills.by-registry.created.table.column.phone',
      additionalClasses: ['transactions-table-header__col--phone'],
    },
    {
      id: 'email',
      title: 'bills.by-registry.created.table.column.email',
      additionalClasses: ['transactions-table-header__col--email'],
    },
    {
      id: 'account-number',
      title: 'bills.by-registry.created.table.column.account-number',
      additionalClasses: ['transactions-table-header__col--account-number'],
    },
    {
      id: 'appointment',
      title: 'bills.by-registry.created.table.column.appointment',
      additionalClasses: ['transactions-table-header__col--appointment'],
    },
    {
      id: 'sum',
      title: 'bills.by-registry.created.table.column.sum',
      additionalClasses: ['transactions-table-header__col--sum'],
    },
    {
      id: 'status',
      title: 'bills.by-registry.created.table.column.status',
      additionalClasses: ['transactions-table-header__col--status'],
    },
    {
      id: 'action',
      title: 'bills.by-registry.created.table.column.action',
      additionalClasses: ['transactions-table-header__col--action'],
    },
  ],
  computed: {
    ...mapState(['selectedCompany']),
    billsRegistryItemsPaged() {
      let _startFrom = (this.currentPage - 1) * this.perPage
      return this.billsRegistryItemsFiltered.slice(
        _startFrom,
        _startFrom + this.perPage
      )
    },

    billsRegistryItemsFiltered() {
      let _transactionToProcess = [...this.billsRegistryItems]

      this.currentPage = 1

      return _transactionToProcess
    },
  },
  methods: {
    handleBillsRegistryItemDeleted(payoutsRegistryItem) {
      $emit(this, 'registryPositionDeleted', payoutsRegistryItem)
    },
    handleBillsRegistryItemUpdated(payoutsRegistryItem) {
      $emit(this, 'registryPositionUpdated', payoutsRegistryItem)
    },
    handlePageChanged(page) {
      this.currentPage = page
    },
    handleSortChanged(newSort) {
      this.sort = { ...newSort }
    },
  },
  emits: ['registryPositionDeleted', 'registryPositionUpdated'],
}
</script>

<style lang="scss" scoped>
.bills-registries-table {
  :deep(.transactions-table) {
    .transactions-table__header {
      display: flex;
      justify-content: space-between;
      padding: 30px 20px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
      border-bottom: 1px solid #eff2f8;
    }

    .transactions-table__body {
      background: #ffffff;
      border-radius: 0 0 20px 20px;
      padding-bottom: 30px;
    }
  }

  :deep(.transactions-table-header) {
    .transactions-table-header__col {
      .transactions-table-header__col--date {
        justify-content: flex-start;
        margin-left: 30px;
      }
      .transactions-table-header__col--phone,
      .transactions-table-header__col--recipient,
      .transactions-table-header__col--email,
      .transactions-table-header__col--account-number {
        .transactions-table-header__col-text {
          width: 120px;
        }
      }
      .transactions-table-header__col--sum,
      .transactions-table-header__col-commission {
        justify-content: center;
      }

      .transactions-table-header__col--p-sum,
      .transactions-table-header__col--p-count {
        justify-content: flex-end;
      }

      .transactions-table-header__col--status {
        justify-content: flex-end;
      }

      .transactions-table-header__col--action {
        margin-right: 35px;
        justify-content: flex-end;
      }
    }
  }
}
</style>
